<template>
  <div class="page-wrap p-3">
    <div class="mt-3 mb-3">
      <a :href="`/students-social-groups`">
        <span><i class="fa fa-chevron-left" aria-hidden="true"></i></span>
        Назад
      </a>
    </div>

    <div class="page-header p-3 mb-3 mt-3">
      <h3>Редактирование данных</h3>
    </div>
  </div>
  <div class="page-content mt-3 mb-3">

    <div class="col-md-12">
      <div class="row col-md-9">
        <div class="el-input-group">
          <label class="form-label col-md-3">
            ИИН
          </label>
          <div class="col-md-9">
            {{ socialGroup.student.iin }}
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <div class="row col-md-9">
        <div class="el-input-group">
          <label class="form-label col-md-3">
            Ф.И.О.
          </label>
          <div class="col-md-9">
            {{ socialGroup.student.lastname }} {{ socialGroup.student.firstname }} {{ socialGroup.student.patronymic }}
          </div>
        </div>
      </div>
    </div>

    <div class="row col-md-9">
      <div class="el-input-group">
        <label for="socialStatusId" class="form-label col-md-3">
          Социальный статус
        </label>
        <div class="col-md-9">
          <select v-model="socialGroup.socialStatusId"
                  :disabled="isDisabled()"
                  id="socialStatusId"
                  class="form-select">
            <option :value="null">-- не выбрано --</option>
            <option v-for="status in socialStatuses" :key="status.id"
                    :value="status.id">
              {{ status.nameRu }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <!-- Инвалидность по слуху/зрению -->
    <div class="row col-md-9">
      <div class="el-input-group">
        <label for="disabilityHearingVision" class="form-label col-md-3">
          Инвалидность по слуху/зрению
        </label>
        <div class="col-md-9">
          <select v-model="socialGroup.disabilityHearingVision"
                  :disabled="isDisabled()"
                  id="disabilityHearingVision"
                  class="form-select">
            <option :value="null">-- не выбрано --</option>
            <option v-for="option in yesNoList" :key="option.id"
                    :value="option.id">
              {{ option.nameRu }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <!-- Инвалидность иное -->
    <div class="row col-md-9">
      <div class="el-input-group">
        <label for="disabilityOther" class="form-label col-md-3">
          Инвалидность иное
        </label>
        <div class="col-md-9">
          <select v-model="socialGroup.disabilityOther"
                  :disabled="isDisabled()"
                  id="disabilityOther"
                  class="form-select">
            <option :value="null">-- не выбрано --</option>
            <option v-for="option in yesNoList" :key="option.id"
                    :value="option.id">
              {{ option.nameRu }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <!-- Даты начала и окончания -->
    <div class="row col-md-9">
      <div class="el-input-group">
        <label for="startDate" class="form-label col-md-3">
          Дата начала
        </label>
        <div class="col-md-9">
          <input
              id="startDate"
              type="date"
              v-model="socialGroup.startDate"
              :disabled="isDisabled()"
              class="form-control"
              required
          />
        </div>
      </div>
    </div>

    <div class="row col-md-9">
      <div class="el-input-group">
        <label for="endDate" class="form-label col-md-3">
          Дата окончания
        </label>
        <div class="col-md-9">
          <input
              id="endDate"
              type="date"
              v-model="socialGroup.endDate"
              :disabled="isDisabled()"
              class="form-control"
              required
          />
        </div>
      </div>
    </div>

    <!-- Подтверждающий документ -->
    <div class="row col-md-9">
      <div class="el-input-group">
        <label for="fileUpload" class="form-label col-md-3">
          Подтверждающий документ (PDF)
        </label>
        <div class="col-md-9" v-if="file">
          <a href="javascript:void(0)" @click="downloadFile(file.uuid)">
            {{ file.name }}
          </a>

          <b-button variant="danger"
                    class="btn-sm"
                    style="margin-left: 20px"
                    v-if="canRemoveFile()"
                    @click="onClickRemoveFile()">
            Удалить
          </b-button>
        </div>
        <div class="col-md-9" v-if="!file">
          <input type="file" id="fileUpload"
                 :disabled="isDisabled()"
                 @change="handleFileUpload" accept=".pdf" class="form-control"/>
        </div>
      </div>
    </div>

    <div class="row col-md-9" v-if="canShowReason()">
      <div class="el-input-group">
        <label for="reason" class="form-label col-md-3">
          Причина отказа
        </label>
        <div class="col-md-9">
          <textarea v-model="socialGroup.reason"
                    :disabled="!canEditReason()"
                    id="reason"
                    style="width: 100%"
                    class="form-label" rows="5"></textarea>
        </div>
      </div>
    </div>
  </div>

  <div class="page-footer justify-content-end">
    <div
        v-if="hasAccess(universityManagerRoles) && (!socialGroup.status || socialGroup.status === StudentApplicationStatusEnum.SENT_FOR_REVISION)">
      <b-button variant="success"
                v-if="socialGroup.status == null || socialGroup.status === StudentApplicationStatusEnum.SENT_FOR_REVISION"
                @click="onClickSave(StudentApplicationStatusEnum.SENT_FOR_APPROVAL)">
        Отправить на согласование
      </b-button>
    </div>

    <div v-if="hasAccess(managerRoles) && socialGroup.status === StudentApplicationStatusEnum.SENT_FOR_APPROVAL">
      <b-button variant="outline-info" class="btn-mr"
                @click="onClickSave(StudentApplicationStatusEnum.SENT_FOR_REVISION)">
        Отправить на доработку
      </b-button>

      <b-button variant="success" class="btn-mr"
                @click="onClickSave(StudentApplicationStatusEnum.APPROVED)">
        Принять
      </b-button>

      <b-button variant="danger" class="btn-mr"
                @click="onClickSave(StudentApplicationStatusEnum.REJECTED)">
        Отказать
      </b-button>
    </div>
  </div>

  <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
</template>

<script>

import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import {showErrorNotify, showSuccessNotify} from "@/utils/notificationUtils";
import socialStatusService from "@/services/socialStatusService";
import studentSocialGroupService from "@/services/studentSocialGroupService";
import authService from "@/services/authService";
import {StudentApplicationStatusEnum} from "@/enum/StudentApplicationStatusEnum";
import {SocialStatusEnum} from "@/enum/SocialStatusEnum";
import fileService from "@/services/fileService";

export default {
  components: {
    VueLoading
  },
  computed: {
    StudentApplicationStatusEnum() {
      return StudentApplicationStatusEnum
    },
    studentUuid() {
      return this.$route.params.uuid;
    }
  },
  data() {
    return {
      isLoading: false,
      socialGroup: {
        uuid: null,
        student: {},
        socialStatusId: null,
        disabilityHearingVision: null,
        disabilityOther: null,
        startDate: null,
        endDate: null,
        status: null,
        reason: null,
        fileId: null
      },
      yesNoList: [
        {id: true, nameRu: "Да"},
        {id: false, nameRu: "Нет"},
      ],
      socialStatuses: [],
      uploadedFile: null,
      file: null,
      managerRoles: authService.getManagerRoles(),
      universityManagerRoles: authService.getUniversityManagerRoles()
    };
  },
  methods: {
    init() {
      this.initSocialStatuses();
      this.findById(this.studentUuid);
    },
    async findById(studentUuid) {
      this.isLoading = true;
      this.socialGroup = await studentSocialGroupService.findByStudentUuid(studentUuid);

      await this.loadFileInfo(this.socialGroup.fileId);
      this.isLoading = false;
    },
    isValid() {
      if (!this.socialGroup.socialStatusId) {
        showErrorNotify("Выберите социальный статус");
        return false;
      }

      if (this.socialGroup.disabilityHearingVision == null) {
        showErrorNotify("Выберите инвалидность по слуху/зрению");
        return false;
      }

      if (this.socialGroup.disabilityOther == null) {
        showErrorNotify("Выберите инвалидность иное");
        return false;
      }

      if (!this.socialGroup.startDate || this.socialGroup.startDate.trim() === '') {
        showErrorNotify("Выберите дату начала");
        return false;
      }

      if (!this.socialGroup.endDate || this.socialGroup.endDate.trim() === '') {
        showErrorNotify("Выберите дату окончания");
        return false;
      }

      if (this.socialGroup.fileId == null && this.uploadedFile == null) {
        showErrorNotify("Загрузите подтверждающий документ в формате PDF");
        return false;
      }

      if (!this.isEndDateValid()) {
        showErrorNotify("Дата окончания должна быть больше даты начала");
        return false;
      }

      if (this.socialGroup.socialStatusId === SocialStatusEnum.GROUP_ONE.id || this.socialGroup.socialStatusId === SocialStatusEnum.FROM_CHILDHOOD.id) {
        const onlyOnePositive = this.socialGroup.disabilityHearingVision !== this.socialGroup.disabilityOther;
        if (!onlyOnePositive) {
          showErrorNotify("Только одно из полей 'Инвалидность по слуху/зрению' и 'Инвалидность иное' должно быть выбрано положительно");
          return false;
        }
      }

      return true;
    },
    isEndDateValid() {
      const {startDate, endDate} = this.socialGroup;
      return new Date(endDate) > new Date(startDate);
    },
    async onClickSave(status) {
      if (status && status === StudentApplicationStatusEnum.SENT_FOR_APPROVAL) {
        if (!this.isValid()) {
          return;
        }
      }

      try {
        this.isLoading = true;

        if (!this.socialGroup.fileId) {
          const formData = new FormData();
          formData.append('studentUuid', this.socialGroup.studentUuid);
          formData.append('file', this.uploadedFile);

          this.file = await fileService.uploadFile(formData);
          this.socialGroup.fileId = this.file.uuid;
        }

        this.socialGroup.status = status;

        this.socialGroup = await studentSocialGroupService.save(this.socialGroup);

        showSuccessNotify("Успешно сохранено!");
      } catch (exc) {
        showErrorNotify("Возникла ошибка при сохранении");
      } finally {
        this.isLoading = false;
      }
    },
    initSocialStatuses() {
      socialStatusService.getAll()
          .then(response => {
            this.socialStatuses = response.sort((a, b) => a.nameRu.localeCompare(b.nameRu));
          });
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.uploadedFile = file;
      } else {
        showErrorNotify("Выберите файл для загрузки");
      }
    },
    hasAccess(...roleGroups) {
      const allRoles = roleGroups.flat();
      return authService.hasAccess(allRoles);
    },
    async loadFileInfo(fileId) {
      if (fileId) {
        this.file = await fileService.loadFileInfo(fileId);
        console.log(this.file);
      }
    },
    async downloadFile() {
      await fileService.download(this.file.uuid, this.file.name);
    },
    async onClickRemoveFile() {
      const confirmed = await confirm("Вы уверены, что хотите удалить данный файл?");
      if (confirmed) {
        try {
          await fileService.deleteFileById(this.file.uuid);

          this.file = null;
          this.socialGroup.fileId = null;

          showSuccessNotify('Успешно удалено');
        } catch (exc) {
          showErrorNotify('Возникла ошибка при удалении');
        }
      }
    },
    isDisabled() {
      const status = this.socialGroup.status;
      if (status && (status === StudentApplicationStatusEnum.APPROVED || status === StudentApplicationStatusEnum.REJECTED)) {
        return true;
      } else if (this.hasAccess(this.managerRoles)) {
        return true;
      } else if (this.hasAccess(this.universityManagerRoles)) {
        if (status && status === StudentApplicationStatusEnum.SENT_FOR_APPROVAL) {
          return true;
        }
        return false;
      }
      return true;
    },
    canRemoveFile() {
      if (this.hasAccess(this.universityManagerRoles)) {
        const status = this.socialGroup.status;
        if (!status || status === StudentApplicationStatusEnum.SENT_FOR_REVISION) {
          return true;
        }
      }
      return false;
    },
    canShowReason() {
      const status = this.socialGroup.status;
      if (status && status === StudentApplicationStatusEnum.APPROVED) {
        return false;
      }

      if (this.hasAccess(this.universityManagerRoles)) {
        if (!status) {
          return false;
        }

        if (status) {
          if (status === StudentApplicationStatusEnum.SENT_FOR_APPROVAL) {
            return false;
          }
        }
      }

      return true;
    },
    canEditReason() {
      const status = this.socialGroup.status;
      if (this.hasAccess(this.managerRoles)) {
        if (status && status === StudentApplicationStatusEnum.SENT_FOR_APPROVAL) {
          return true;
        }
      }
      return false;
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style scoped>
.row {
  padding-top: 5px;
}

.btn-mr {
  margin-right: 15px;
}
</style>
